import { createIntl, createIntlCache } from "react-intl";
import zhCNTranslation from "./zh-CN.json";
import zhTWTranslation from "./zh-TW.json";
import enUSTranslation from "./en-US.json";

// 定义应用支持的语言和默认语言
const localeData = {
	"zh-CN": zhCNTranslation,
	"zh-TW": zhTWTranslation,
	"en-US": enUSTranslation,
};

// 创建一个格式化消息的函数
export default function formatMessageSelf(locale) {
	// 创建缓存和国际化实例
	const cache = createIntlCache();
	const intl = createIntl(
		{
			locale: locale,
			messages: localeData[locale],
		},
		cache
	);

	return (id) => intl.formatMessage({ id });
}
